import { PaymentModuleId } from '@foundation/apis/payments/types/PaymentModuleId';

export function isCard(module: PaymentModuleId): boolean {
  return (
    module === PaymentModuleId.BraintreeCard ||
    module === PaymentModuleId.WorldpayCard ||
    module === PaymentModuleId.WorldpayJCB ||
    module === PaymentModuleId.FlutterwaveCreditCard ||
    module === PaymentModuleId.NuveiCreditCard
  );
}

export function isPayPal(module: PaymentModuleId): boolean {
  return module === PaymentModuleId.BraintreePayPal;
}

export function isPostFinance(module: PaymentModuleId): boolean {
  return module === PaymentModuleId.DirectDebitPostFinance;
}

export function isMpmSepa(module: PaymentModuleId): boolean {
  return module === PaymentModuleId.Sepa;
}

export function isDirectDebitLsv(module: PaymentModuleId): boolean {
  return module === PaymentModuleId.DirectDebitLSV;
}

export function isSepa(module: PaymentModuleId): boolean {
  return isMpmSepa(module) || isBraintreeSepa(module);
}

export function isDirectDebit(module: PaymentModuleId): boolean {
  return (
    isMpmSepa(module) ||
    isBraintreeSepa(module) ||
    isDirectDebitLsv(module) ||
    isPostFinance(module)
  );
}

export function isBraintreeSepa(module: PaymentModuleId): boolean {
  return module === PaymentModuleId.BraintreeSepa;
}

export function isGooglePay(module: PaymentModuleId): boolean {
  return module === PaymentModuleId.BraintreeGooglePay;
}

export function isKlarna(module: PaymentModuleId): boolean {
  return module === PaymentModuleId.WorldpayKlarna;
}
